// extracted by mini-css-extract-plugin
export default {"customContainer":"OrdersTab_customContainer__HQqwB","myCustomClassFont":"OrdersTab_myCustomClassFont__OCcQr","iconContiner":"OrdersTab_iconContiner__EDuDW"};